import { createAction, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { RecordConferenceActionInterface, StopRecordConference } from '../../types';

type RecordState = {
    isRecording: boolean;
    recordStartTime?: number;
};

const initialState: RecordState = {
    isRecording: false,
    recordStartTime: undefined,
};

const recordSlice = createSlice({
    name: 'record',
    initialState,
    reducers: {
        setIsRecording(state, action: PayloadAction<boolean>) {
            const isRecording = action.payload;

            state.isRecording = isRecording;
            state.recordStartTime = isRecording ? Date.now() : undefined;
        },
        resetRecordState() {
            return initialState;
        },
    },
});

export const recordConferenceAction = createAction<RecordConferenceActionInterface | undefined>(
    'conference/record/recordConference'
);

export const restartRecordConferenceAction = createAction<RecordConferenceActionInterface | undefined>(
    'conference/record/restartRecordConference'
);

export const setIsLocalRecordingAction = createAction<boolean>('conference/record/setIsLocalRecordingAction');
export const stopRecordConferenceAction = createAction<StopRecordConference | undefined>(
    'conference/record/stopRecordConference'
);
export const setIsMeLocalRecordingAction = createAction<boolean>('conference/record/setIsMeLocalRecording');
export const recordHaveBeenSavedAction = createAction<void>('conference/record/recordHaveBeenSavedAction');
export const setIsRecordingAction = createAction<boolean>('conference/record/setIsRecording');
export const { setIsRecording, resetRecordState } = recordSlice.actions;
export const recordReducer = recordSlice.reducer;
